import React, { useState } from 'react'
import style from './detatilCard.module.css'
import { useNavigate } from 'react-router'

const DetailCard = ({ homeImage, reversed = false, title, subtitle, description }) => {
  const navigate = useNavigate()
  const [isImageExpanded, setIsImageExpanded] = useState(false)

  return (
    <div>
      <div 
        className={style.bodyCard} 
        style={{
          flexDirection: reversed ? "row-reverse" : "row"
        }}
      >
        <div className={style.cardDetails}>
          <p>{subtitle || "Notre identité"}</p>
          <h3>{title || "Positionnement global"}</h3>
          <p>
            {description || `GET Conseil est un cabinet pluridisciplinaire de droit congolais spécialisé dans l'optimisation
            de la gestion des organisations. Il accompagne les entreprises, institutions publiques et
            privées dans la maîtrise de leurs ressources, la conformité administrative, la performance
            financière et la sécurité juridique. Grâce à une approche rigoureuse, structurée et centrée sur
            l'efficience, GET Conseil se positionne comme un partenaire stratégique de gestion globale.`}
          </p>
          <div 
            className={style.info}
            onClick={() => navigate("/about")}
          >
            Plus d'info
          </div>
        </div>

        <div 
          className={style.cardImages}
          onClick={() => setIsImageExpanded(true)}
        >
          <img src={homeImage} alt="Illustration Get-Conseil" />
          <div className={style.imageOverlay}>
            <span className={style.zoomIcon}>🔍</span>
            <span className={style.zoomText}>Cliquer pour agrandir</span>
          </div>
        </div>
      </div>

      {/* Modal Overlay pour l'image agrandie */}
      {isImageExpanded && (
        <div 
          className={style.imageModal}
          onClick={() => setIsImageExpanded(false)}
        >
          <div className={style.modalContent} onClick={(e) => e.stopPropagation()}>
            <button 
              className={style.closeBtn}
              onClick={() => setIsImageExpanded(false)}
            >
              ✕
            </button>
            <img src={homeImage} alt="Illustration Get-Conseil agrandie" />
          </div>
        </div>
      )}
    </div>
  )
}

export default DetailCard